import { INDENT_STEP, INDENT_TYPES } from './indentConfig';

/**
 * Global attribute config for IndentExtension.
 * Adds margin-left-based indent to paragraph, heading, bulletList and orderedList nodes.
 */
export const indentAttribute = [
    {
        types: INDENT_TYPES,
        attributes: {
            indent: {
                default: 0,
                parseHTML: (el) => Math.round(parseFloat(el.style.marginLeft || '0') / INDENT_STEP) || 0,
                renderHTML: (attrs) => attrs.indent ? { style: `margin-left: ${attrs.indent * INDENT_STEP}em` } : {},
            },
        },
    },
];
